module.exports = __webpack_public_path__ + "img/rank2.2001e587.png";